import { render, staticRenderFns } from "./PersonLookupMenu.vue?vue&type=template&id=58a6cf77"
import script from "./PersonLookupMenu.vue?vue&type=script&lang=ts"
export * from "./PersonLookupMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports